<div class="c-flex-float-list">
  <div class="p-sub-column-layout02-flex">
    <dl class="p-payment-detailes-summary-block">
      <div class="c-float-list01__item">
        <dt
          *ngIf="!data.isKeepMyFare"
          class="c-float-list01__title c-float-list01__title--em c-float-list01__contents--fs16 c-float-list01__title--gray90"
          [innerHTML]="'label.totalAmount' | staticMsg"
        ></dt>
        <dt
          *ngIf="data.isKeepMyFare"
          class="c-float-list01__title c-float-list01__title--em c-float-list01__contents--fs16 c-float-list01__title--gray90"
          [innerHTML]="'label.paymentTotalAmountNotPurchased' | staticMsg"
        ></dt>
        <dd class="c-float-list01__contents c-float-list01__contents--fs24">
          <span class="u-font-24">
            <!-- 支払総額 -->
            <span [innerHTML]="data.totalAmount || 0 | amountFormat : undefined : data.currencyCode"></span>
          </span>
          <span
            *ngIf="isPromotion"
            class="u-visually-hidden"
            [innerHTML]="'label.paymentTotalAmount' | staticMsg"
          ></span>
        </dd>
      </div>
      <div *ngIf="isPromotion" class="c-float-list01__item">
        <dt class="c-float-list01__title"></dt>
        <dd class="c-float-list01__contents">
          <span class="u-font-20 u-weight-normal">
            <!-- プロモ適用前支払総額 -->
            <del [innerHTML]="data.totalFeePreApply | amountFormat : undefined : data.currencyCode"></del>
          </span>
          <span
            *ngIf="isPromotion"
            class="u-visually-hidden"
            [innerHTML]="'lable.beforeTotalAmount' | staticMsg"
          ></span>
        </dd>
      </div>
      <!--搭乗者種別毎の人数 -->
      <div class="c-float-list01__item">
        <dd class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal">
          {{ passengerNumbersText }}
        </dd>
      </div>
      <div *ngIf="isPromotion" class="c-float-list01__item">
        <!-- プロモーションコード -->
        <dt class="c-float-list01__title" [innerHTML]="'label.applidPromotion1' | staticMsg"></dt>
        <dd class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal">
          {{ data.promotionCode }}
        </dd>
      </div>
    </dl>
  </div>
  <div class="p-sub-column-layout02-flex p-payment-detailes-line-sp-only">
    <dl class="p-payment-detailes-summary-block">
      <div *ngIf="isTotalFare" class="c-float-list01__item">
        <!-- 運賃総額 -->
        <dt class="c-float-list01__title" [innerHTML]="'label.fare' | staticMsg"></dt>
        <dd class="c-float-list01__contents">
          <span class="c-float-list01__contents--fs16 u-weight-bold">
            <p [innerHTML]="data.totalFare | amountFormat : undefined : data.currencyCode"></p>
          </span>
        </dd>
      </div>
      <div *ngIf="!isTotalFare" class="c-float-list01__item">
        <!-- 運賃総額(フライトサーチャージ総額併記) -->
        <dt class="c-float-list01__title" [innerHTML]="'lable.fareAndVariousCharge' | staticMsg"></dt>
        <dd class="c-float-list01__contents">
          <span class="c-float-list01__contents--fs16 u-weight-normal">
            <p [innerHTML]="data.totalFareSurcharge | amountFormat : undefined : data.currencyCode"></p>
          </span>
        </dd>
      </div>
      <div *ngIf="isCanada" class="c-float-list01__item">
        <!-- 燃油特別付加運賃等 -->
        <dt class="c-float-list01__title" [innerHTML]="'lable.fuelSurcharge' | staticMsg"></dt>
        <dd class="c-float-list01__contents">
          <span class="c-float-list01__contents--fs16 u-weight-normal">
            <p [innerHTML]="data.fuelFee | amountFormat : undefined : data.currencyCode"></p>
          </span>
        </dd>
      </div>
      <div *ngIf="!isCanada" class="c-float-list01__item">
        <!-- 税金総額 -->
        <dt class="c-float-list01__title" [innerHTML]="'label.taxFare2' | staticMsg"></dt>
        <dd class="c-float-list01__contents">
          <span class="c-float-list01__contents--fs16 u-weight-normal">
            <p [innerHTML]="data.totalTax | amountFormat : undefined : data.currencyCode"></p>
          </span>
        </dd>
      </div>
      <div *ngIf="isCanada" class="c-float-list01__item">
        <!-- 各国諸税・空港使用料等 -->
        <dt class="c-float-list01__title" [innerHTML]="'lable.taxesFeeArges' | staticMsg"></dt>
        <dd class="c-float-list01__contents">
          <span class="c-float-list01__contents--fs16 u-weight-normal">
            <p [innerHTML]="data.countryTaxAndPayment | amountFormat : undefined : data.currencyCode"></p>
          </span>
        </dd>
      </div>
      <div *ngIf="!isCanada" class="c-float-list01__item">
        <!-- 発券手数料 -->
        <dt class="c-float-list01__title" [innerHTML]="'label.fee' | staticMsg"></dt>
        <dd class="c-float-list01__contents">
          <span class="c-float-list01__contents--fs16 u-weight-normal">
            <p [innerHTML]="0 | amountFormat : undefined : data.currencyCode"></p>
          </span>
        </dd>
      </div>
    </dl>
    <div class="p-payment-detailes-summary-block p-payment-detailes-line">
      <dl class="c-float-list01">
        <div *ngIf="data.ancillaryNonTaxFee !== 0" class="c-float-list01__item">
          <!-- Ancillaryサービス税抜総額 -->
          <dt class="c-float-list01__title" [innerHTML]="'label.paidServiceCharges' | staticMsg"></dt>
          <dd class="c-float-list01__contents">
            <span class="c-float-list01__contents--fs16 u-weight-normal">
              <p [innerHTML]="data.ancillaryNonTaxFee | amountFormat : undefined : data.currencyCode"></p>
            </span>
          </dd>
        </div>
        <div *ngIf="data.ancillaryTotalTax !== 0" class="c-float-list01__item">
          <!-- Ancillaryサービス税金総額 -->
          <dt class="c-float-list01__title" [innerHTML]="'label.paidServiceTaxAmount' | staticMsg"></dt>
          <dd class="c-float-list01__contents">
            <span class="c-float-list01__contents--fs16 u-weight-normal">
              <p [innerHTML]="data.ancillaryTotalTax | amountFormat : undefined : data.currencyCode"></p>
            </span>
          </dd>
        </div>
      </dl>
    </div>
  </div>
</div>

<div *ngIf="data.alertLabelTxt.length !== 0" class="p-alert-label-txt">
  <div *ngFor="let str of data.alertLabelTxt" class="p-alert-label-txt_content">
    <em class="p-alert-label-txt_content_txt" [innerHTML]="str | staticMsg"></em>
  </div>
</div>
